<script setup lang="ts">
import { computed } from 'vue'
import { useRouter } from 'vue-router'
import { useCurrencyFormat } from '@/utils'

const router = useRouter()
const defaultAvatar = '/images/picture-not-found.jpg'

interface Props {
  profileImage?: string
  fullname: string
  membercardName: string
  membercardCash: string
  memberPoint: number
  memberPointExpire: string
  expireDate: string
}

const props = defineProps<Props>()
const displayImage = computed(() => props.profileImage || defaultAvatar)

const handleSettingOnMobile = () => {
  router.push({ name: 'Setting' })
}
</script>

<template>
  <v-card class="tw-rounded-xl tw-mx-3 tw-mb-3">
    <v-card-item class="tw-rounded-xl border border-primary tw-shadow-md tw-bg-[#F0FCFF] tw-pt-5 tw-pb-3 md:tw-mx-0">
      <template v-slot:prepend>
        <div class="tw-flex tw-flex-col tw-gap-2 tw-items-center">
          <v-img
            cover
            class="tw-h-[60px] tw-w-[60px] tw-rounded-full md:tw-h-[120px] md:tw-w-[120px]"
            :src="displayImage"
            alt="profile2"
          >
            <template v-slot:error>
              <v-img
                cover
                class="tw-h-[60px] tw-w-[60px] tw-rounded-full md:tw-h-[120px] md:tw-w-[120px]"
                :src="defaultAvatar"
                alt="profile2"
              />
            </template>
          </v-img>
          <v-card-subtitle>
            <div
              class="tw-mr-1.5 tw-rounded-full tw-text-[12px] tw-px-2 tw-py-1 tw-w-fit tw-font-bold tw-bg-gradient-to-tr tw-from-[#919295] tw-to-gray-800 tw-text-white"
            >
              <p>{{ membercardName }}</p>
            </div>
          </v-card-subtitle>
        </div>
      </template>

      <v-card-title class="text-primary2 tw-font-bold tw-text-[16px]">{{ fullname }}</v-card-title>
      <template v-slot:append>
        <div class="tw-absolute tw-top-10 tw-right-12 tw-border tw-rounded-full tw-p-1">
          <v-btn class="tw-block" icon elevation="0" size="medium" @click="handleSettingOnMobile()">
            <v-icon icon="mdi-cog-outline" />
          </v-btn>
        </div>
      </template>

      <v-card-subtitle class="tw-flex tw-item-center">
        <span class="tw-me-1.5 tw-text-black tw-text-[14px]"
          >{{ $t('membercard.accumulated_point') }} {{ useCurrencyFormat(memberPoint || 0) }}</span
        >
        <v-avatar class="pa-2" color="black" size="8">
          <span class="tw-text-[10px]">P</span>
        </v-avatar>
      </v-card-subtitle>

      <v-card-subtitle>
        <p class="tw-text-aura-error tw-text-[14px] tw-font-bold">
          {{ memberPointExpire }}
        </p>
      </v-card-subtitle>

      <v-card-subtitle>
        <p class="tw-text-black tw-text-[12px] tw-font-bold">
          {{ $t('membercard.money_remain') }} :
          <span class="tw-me-1.5 tw-text-black tw-text-[14px]">{{ useCurrencyFormat(membercardCash || 0) }}</span>
        </p>
      </v-card-subtitle>

      <v-card-subtitle class="tw-items-center" v-if="membercardName !== 'Lifetime Infinite'">
        <p class="text-error tw-text-[14px] tw-font-bold">
          {{ $t('membercard.expire_date') + ' : ' + expireDate }}
        </p>
      </v-card-subtitle>
    </v-card-item>
  </v-card>
</template>
